module.exports = __webpack_public_path__ + "static/media/chevron-down.60a010a7.svg";